import { render, staticRenderFns } from "./ListAssignedRoutes.vue?vue&type=template&id=0db2b22a&scoped=true&"
import script from "./ListAssignedRoutes.vue?vue&type=script&lang=js&"
export * from "./ListAssignedRoutes.vue?vue&type=script&lang=js&"
import style0 from "./ListAssignedRoutes.vue?vue&type=style&index=0&id=0db2b22a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db2b22a",
  null
  
)

export default component.exports